<ftr-panel
  [panelStyle]="!horizontalAutoMargin || noMargin ? 'flat' : pageStyle === 'default' ? 'centered' : pageStyle"
  displayMode="FILL"
>
  <ng-container *ngTemplateOutlet="childContent" />
</ftr-panel>

<ng-template #childContent><ng-content /></ng-template>
